import { Image } from "~/ui";

interface ShelfCycleLogoProps {
  size?: number;
}

const defaultLogoSize = 40;

export const ShelfCycleLogo = ({ size = defaultLogoSize }: ShelfCycleLogoProps) => (
  <Image alt="ShelfCycle logo" height={size} src="/img/shelfcycle-logo-duo.png" width={size} />
);
